import { render, staticRenderFns } from "./ClinicProviderFamilies.vue?vue&type=template&id=5646b89e"
import script from "./ClinicProviderFamilies.vue?vue&type=script&lang=js"
export * from "./ClinicProviderFamilies.vue?vue&type=script&lang=js"
import style0 from "./ClinicProviderFamilies.vue?vue&type=style&index=0&id=5646b89e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports